// import {
//   useEffect,
//   useState,
//   type ComponentType,
// } from "react";
// import { useNavigate } from "react-router-dom";


// type RemoteComponent =
//   ComponentType<Record<string, unknown>>;
// const HOST_TOKEN = "my-secret-token";
// type UseNotFoundUserReturn = {
//   handleContinue: () => Promise<void>;
// Button: RemoteComponent | null;
//   loading: boolean;
// };

// export default function useNotFoundUser():
// UseNotFoundUserReturn {

//  const [Button, setButton] =
//   useState<RemoteComponent | null>(
//     null
//   );

//   const navigate = useNavigate();

//   useEffect(() => {
//     import("remote_app/Button").then(
//       (mod) => {
//         setButton(
//   () => mod.default as RemoteComponent
// );
//       }
//     );
//   }, []);

//   const handleContinue = async (): Promise<void> => {
//     try {
//       const email =
//         sessionStorage.getItem("invalidEmail");

//       if (!email) {
//         console.log("Email not found");
//         return;
//       }

//       const mod =
//         await import("service1/authService");

//       const generateOtp =
//         mod.default.generateOtp;

//       const data = await generateOtp(
//         {
//           email,
//         },
//         HOST_TOKEN
//       );

//       console.log("OTP RESPONSE =", data);

//       if (Number(data.statusType) === 1) {
//         navigate("/otp", {
//           state: {
//             maskedEmail: data.maskedEmail,
//           },
//         });
//       } else {
//         console.log(data.message);
//       }
//     } catch (error) {
//       console.error(
//         "Error generating OTP:",
//         error
//       );
//     }
//   };

//   return {
//     handleContinue,
//     Button,
//     loading: !Button,
//   };
// }










import {
  useEffect,
  useState,
  type ComponentType,
} from "react";

import { useNavigate } from "react-router-dom";

type RemoteComponent =
  ComponentType<Record<string, unknown>>;

type UseNotFoundUserReturn = {
  handleContinue: () => Promise<void>;
  Button: RemoteComponent | null;
  loading: boolean;
  submitting: boolean;
  authToken: string;
};

export default function useNotFoundUser():
UseNotFoundUserReturn {

  const [Button, setButton] =
    useState<RemoteComponent | null>(
      null
    );

  const [authToken, setAuthToken] =
    useState("");

  const [authorized, setAuthorized] =
    useState(false);

  const [validating, setValidating] =
    useState(true);

  const [submitting, setSubmitting] =
    useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const initialize = async () => {
      try {
        const token =
          sessionStorage.getItem(
            "AUTH_TOKEN"
          );

        const type =
          sessionStorage.getItem(
            "AUTH_TYPE"
          );

        if (!token || !type) {
          navigate("/", {
            replace: true,
          });
          return;
        }

        setAuthToken(token);

        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/api/amibit/fwp/validate`,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              token,
              type: Number(type),
            }),
          }
        );

        if (!response.ok) {
          throw new Error(
            `Validation failed: ${response.status}`
          );
        }

        const data =
          await response.json();

        if (!data.success) {
          navigate("/", {
            replace: true,
          });
          return;
        }

        setAuthorized(true);

        const buttonModule =
          await import(
            "remote_app/Button"
          );

        setButton(
          () =>
            buttonModule.default as RemoteComponent
        );

      } catch (error) {

        console.error(
          "Token validation error:",
          error
        );

        navigate("/", {
          replace: true,
        });

      } finally {

        setValidating(false);

      }
    };

    initialize();
  }, [navigate]);

  const handleContinue =
    async (): Promise<void> => {

    if (submitting) return;

    setSubmitting(true);

    try {
      const email =
        sessionStorage.getItem(
          "invalidEmail"
        );

      if (!email) {
        console.log(
          "Email not found"
        );
        return;
      }

      const mod =
        await import(
          "service1/authService"
        );

      const generateOtp =
        mod.default.generateOtp;

      const data =
        await generateOtp(
          {
            email,
          },
          authToken
        );

      console.log(
        "OTP RESPONSE =",
        data
      );

      if (
        Number(data.statusType) === 1
      ) {

        setTimeout(() => {

          navigate("/otp", {
            state: {
              maskedEmail:
                data.maskedEmail,
            },
          });

        }, 500);

      } else {

        console.log(
          data.message
        );

      }

    } catch (error) {

      console.error(
        "Error generating OTP:",
        error
      );

    } finally {

      setSubmitting(false);

    }
  };

  return {
    handleContinue,
    Button,
    authToken,
    submitting,
    loading:
      validating ||
      !authorized ||
      !Button,
  };
}